/**
 * Sticky Add-to-Cart — mirrors the original ATC button when it scrolls
 * out of view. Submission is delegated to the original <form> via the
 * sticky button's `form="..."` attribute, so all variant/quantity logic
 * stays in the existing product form.
 */
(function () {
  if (typeof window === 'undefined') return;

  function init() {
    var section = document.querySelector('.main-product-section, .main-product[data-section-id]');
    if (!section) return;

    var sticky = document.querySelector('.haut-sticky-atc');
    if (!sticky) return;

    var originalBtn = section.querySelector('.product-form__submit');
    var originalPrice = section.querySelector('.main-product-price-org, [id^="price-"]');
    var stickyBtn = sticky.querySelector('.haut-sticky-atc__button');
    var stickyPrice = sticky.querySelector('.haut-sticky-atc__price');

    if (!originalBtn) return;

    // 1) Show/hide sticky based on original ATC visibility + scroll threshold.
    //    Also toggle body.haut-sticky-active so CSS can lift Smile/Wizybot
    //    launchers above the sticky bar.
    var SCROLL_THRESHOLD = 120; // px — avoid showing on initial page load
    var lastIntersecting = true; // assume ATC is visible until proven otherwise

    // Measure the sticky bar's real height (accounting for safe-area-inset
    // on iPhones with home-bar) and expose it as --haut-sticky-lift so the
    // launcher CSS lifts launchers exactly above the bar with a buffer.
    function updateStickyLift() {
      var h = sticky.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--haut-sticky-lift', (h + 16) + 'px');
      }
    }

    function setActive(isActive) {
      // Suppress on initial load: only show after user has scrolled
      if (isActive && window.scrollY < SCROLL_THRESHOLD) {
        isActive = false;
      }
      sticky.classList.toggle('haut-sticky-atc--visible', isActive);
      document.body.classList.toggle('haut-sticky-active', isActive);
      if (isActive) updateStickyLift();
    }

    function recompute() {
      setActive(!lastIntersecting);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          lastIntersecting = entry.isIntersecting;
          recompute();
        });
      }, { threshold: 0, rootMargin: '0px 0px -10px 0px' });
      io.observe(originalBtn);
    } else {
      // Fallback for very old browsers
      setActive(true);
    }

    // Re-check on scroll so the threshold gating works smoothly
    var scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (!scrollTicking) {
        window.requestAnimationFrame(function () {
          recompute();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });

    // Re-measure lift on resize / orientationchange (safe-area changes on rotate)
    window.addEventListener('resize', updateStickyLift, { passive: true });
    window.addEventListener('orientationchange', updateStickyLift);

    // Initial measurement (sticky is hidden but offsetHeight still reads layout)
    updateStickyLift();

    // 2) Mirror price changes from the original price block
    if (originalPrice && stickyPrice) {
      stickyPrice.innerHTML = originalPrice.innerHTML;
      var priceObserver = new MutationObserver(function () {
        stickyPrice.innerHTML = originalPrice.innerHTML;
      });
      priceObserver.observe(originalPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // 3) Mirror disabled/sold-out state and label
    function syncButton() {
      if (!stickyBtn) return;
      var disabled = originalBtn.hasAttribute('disabled');
      var label = (originalBtn.textContent || '').trim();
      stickyBtn.disabled = disabled;
      if (label) stickyBtn.textContent = label;
    }
    syncButton();
    var btnObserver = new MutationObserver(syncButton);
    btnObserver.observe(originalBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    // 4) Track click for analytics (datalayer push for GTM)
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'sticky_atc_click',
            location: 'sticky_bar',
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
